<template>
  <div class="md-layout-item md-size-100">
    <md-card class="md-card-stats">
      <md-card-header
        class="md-card-header-icon card-position"
        :class="getClass(color)"
      >
        <div class="card-icon">
          <p>{{ title }}</p>
        </div>
        <div class="card-split">
          <div
            v-for="(section, index) in displayData"
            :key="index"
            class="section-wrapper"
          >
            <div class="section">
              <p class="category">{{ section.header }}</p>
              <h3 class="title">{{ section.value }}</h3>
            </div>
            <!-- Show arrow icon only if not the last item -->
            <div v-if="index < displayData.length - 1" class="arrow-wrapper">
              <md-icon class="arrow-icon">keyboard_double_arrow_right</md-icon>
            </div>
          </div>
        </div>
      </md-card-header>
      <div class="footer-wrapper">
        <md-card-actions class="card-position">
          <loading-icon-text-button
            v-if="userHasRole('super-admin') || isPodManager"
            class="md-primary md-md"
            icon="file_download"
            :loading="false"
            @click="exportCSV"
          >
            Export Pull Trough Report
          </loading-icon-text-button>
        </md-card-actions>
      </div>
    </md-card>
  </div>
</template>
<script>
import {StatsCard} from "../../../components";
import filters from "../../../components/utils/filters";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import WaitingDialog from "@/components/Dialogs/WaitingDialog";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import {mapGetters} from "vuex";

export default {
  components: {
    StatsCard,
    LoadingIconTextButton,
    WaitingDialog,
    ConfirmDialog
  },
  props:{
    icon: {
      type: String,
      default: 'money',
    },
    color: {
      type: String,
      default: 'blue',
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: () => []
    },
    csvData: {
      type: Array,
      default: () => []
    },
    filter:{
      type: String,
      default: null
    }
  },
  computed:{
    ...mapGetters([
      "userHasRole",
      "isPodManager"
    ]),
    displayData() {
        if (!this.value || this.value.length === 0) return [];
        const result = [];
        for (let i = 0; i < this.value.length; i++) {
          result.push({
            header: this.value[i].header,
            value: this.value[i].value
          });
          // If there is a next item, calculate the conversion percentage.
          if (i < this.value.length - 1) {
            const currentVal = this.value[i].value;
            const nextVal = this.value[i + 1].value;
            const conversionValue =
              currentVal > 0 ? Math.round((nextVal / currentVal) * 100) + '%' : '0%';
            result.push({
              header: 'Conversion',
              value: conversionValue
            });
          }
        }
        return result;
    },
    dataToShow(){
      if(this.filter){
        return filters[this.filter](this.value);
      }
      return this.value;
    }
  },
  methods:{
    ...filters,
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    async exportCSV() {
      try {
          this.showLoadingDialog("Processing", "Your report is being generated. You will receive an email shortly.");
          let response = await this.$store.dispatch("export_approval_pull_through", {
            csvData: this.csvData,
            funnelType: this.title.toLowerCase()
          });

          if (response.success) {
            this.closeDialog();
            this.showConfirmDialog("Success", response.message);
          }
        } catch (error) {
          console.error("Export Error:", error);
          this.showConfirmDialog("Error", "There was an issue processing your report.");
        }
      },
      showLoadingDialog(title, message) {
        this.$modal.show(WaitingDialog, {
          title: title,
          message: message,
        });
      },
      showConfirmDialog(title, message) {
        this.$modal.show(ConfirmDialog, {
          title: title,
          message: message,
          confirmText: 'Ok',
        });
      },
      closeDialog()
      {
        if (this.$modal.submit) {
          this.$modal.submit();
        }
      },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
}
</script>
<style scoped lang="scss">
.card-split {
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-wrapper {
  display: flex;
  align-items: center;
}

.section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0px;
}

.arrow-wrapper {
  display: flex;
  align-items: center;
  margin: 20px;
}

p.category {
  white-space: nowrap;
  overflow: hidden;
  font-size: 16px !important;
  padding: 5px 0px;
}

.title {
  font-size: 30px !important;
  font-weight: bold !important;
}

.card-icon {
  margin-right: 0 !important;
  color: white;
}

.card-position {
  text-align: right;
}

.footer-wrapper {
  margin-top: 10px;
  min-height: 50px;
}

</style>
